export const set_languages = (state, languages) =>
  (state.languages = languages);
export const set_alert = (state, alert) => (state.alert = alert);
